module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0020.jpg?v=22d42641";